import { styled } from "styled-system/jsx";

export const SelectableLargeRoundedButton = styled("button", {
  base: {
    fontFamily: "body",
    display: "flex",
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
    gap: "150",
    borderRadius: "full",
    border: "1px solid",
    borderColor: "border.lightest",
    outline: "1px solid",
    outlineColor: "transparent",
    bg: "bg.wa.lightest",
    px: "200",
    py: "250",
    cursor: "pointer",
    color: "text.mid",
    transitionDuration: "normal",
    transitionProperty: "border-color, color, outline-color, background",
    transitionTimingFunction: "default",
    _hover: {
      borderColor: "border.light",
      outlineColor: "border.light",
      bg: "white",
    },
    _focusVisible: {
      borderColor: "border.light",
      outlineColor: "border.light",
      bg: "white",
    },
    _disabled: {
      opacity: 0.6,
      cursor: "not-allowed",
      _hover: {
        borderColor: "border.lightest",
        outlineColor: "transparent",
      },
      _focusVisible: {
        borderColor: "border.lightest",
        outlineColor: "transparent",
      },
    },
  },
  variants: {
    visual: {
      primary: {
        _selected: {
          bg: "white",
          borderColor: "border.dark",
          outlineColor: "border.dark",
          color: "text.dark",
          _hover: {
            borderColor: "border.dark",
            outlineColor: "border.dark",
          },
          _focusVisible: {
            borderColor: "border.dark",
            outlineColor: "border.dark",
          },
        },
      },
      "accent.blue": {
        _selected: {
          bg: "bg.accent.blue.dark",
          color: "white",
          borderColor: "transparent",
          _hover: {
            borderColor: "transparent",
            outlineColor: "transparent",
            bg: "bg.accent.blue.dark",
          },
          _focusVisible: {
            borderColor: "transparent",
            outlineColor: "transparent",
            bg: "bg.accent.blue.dark",
          },
        },
      },
    },
  },
  defaultVariants: {
    visual: "primary",
  },
});
